var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import DataForm from "~/components/common/data-form.vue";
import { OutsourceSettlevOucherService } from "~/services/domain-service/outsource-settle-manage-index.service";
import { PageService } from "~/utils/page.service";
var ModifyCompany = /** @class */ (function (_super) {
    __extends(ModifyCompany, _super);
    function ModifyCompany() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            outBatch: "" //批次号 必传
        };
        _this.dataList = [];
        _this.selectionList = [];
        return _this;
    }
    ModifyCompany.prototype.refreshList = function () { };
    ModifyCompany.prototype.close = function () { };
    ModifyCompany.prototype.mounted = function () {
        this.refreshData();
    };
    ModifyCompany.prototype.onCaseRowChange = function () {
        this.refreshData();
    };
    /**
     * 查询详情列表
     */
    ModifyCompany.prototype.refreshData = function () {
        var _this = this;
        this.queryModel.outBatch = this.caseRow.outBatch;
        this.queryModel.outsourceId = this.caseRow.outsourceId;
        this.outsourceSettlevOucherService
            .getSettlementSheetDetailPageList(this.queryModel)
            .subscribe(function (data) {
            _this.dataList = data.content;
        });
    };
    /**
     * 导出明细
     */
    ModifyCompany.prototype.clickExport = function () {
        var _this = this;
        //需要导出的列表 ids
        var idArray = [];
        this.selectionList.map(function (v) {
            idArray.push(v.id);
        });
        var param = {
            ids: idArray
        };
        this.outsourceSettlevOucherService
            .exportSettlementSheetDetail(param)
            .subscribe(function (data) {
            _this.$message.success("导出成功!");
            window.open(data.url);
        });
    };
    __decorate([
        Dependencies(OutsourceSettlevOucherService)
    ], ModifyCompany.prototype, "outsourceSettlevOucherService", void 0);
    __decorate([
        Dependencies(PageService)
    ], ModifyCompany.prototype, "pageService", void 0);
    __decorate([
        Prop({ required: true })
    ], ModifyCompany.prototype, "caseRow", void 0);
    __decorate([
        Emit("refreshList")
    ], ModifyCompany.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ModifyCompany.prototype, "close", null);
    __decorate([
        Watch("caseRow")
    ], ModifyCompany.prototype, "onCaseRowChange", null);
    ModifyCompany = __decorate([
        Component({
            components: {
                DataForm: DataForm
            }
        })
    ], ModifyCompany);
    return ModifyCompany;
}(Vue));
export default ModifyCompany;
